/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Conflict problems.
 */
export type ConflictProblems =
    | Truvity.ConflictProblems.Conflict
    | Truvity.ConflictProblems.ConflictBlobRestoreInProgress
    | Truvity.ConflictProblems.ConflictResource;

export namespace ConflictProblems {
    export interface Conflict extends Truvity.ProblemConflict {
        type: '/conflict';
    }

    export interface ConflictBlobRestoreInProgress extends Truvity.ProblemConflictBlobRestoreInProgress {
        type: '/conflict/blob/restore-in-progress';
    }

    export interface ConflictResource extends Truvity.ProblemConflictResource {
        type: '/conflict/resource';
    }
}
